import React, { useState } from 'react';
import styled from '@emotion/styled';
import { XIcon } from '../../../components/icons';

interface PropTypes {
  fileNameToDisplay: string;
  onRemoveClick: () => void;
  onSaveFileClick?: (e: any) => void;
  filePath?: string;
  changeCustomFileName: (newName: string) => void;
}

const DocumentUploaded = styled.div`
  background-color: #f7f7f9;
  border-radius: 5px;
  height: 40px;
  padding: 10px 16px;
  display: inline-block;
  width: 376px;
  margin-top: 6px;
  margin-left: 200px;
  position: relative;
`;
const InputStyles = styled.input`
  background-color: #fff;
  border-radius: 5;
  height: 30px;
  width: 278px;
  border: 1px solid #ff867f;
  position: absolute;
  top: 6px;
  left: 10px;
  :focus {
    border: 1px solid #ff867f;
  }
`;

function ImportedFileTag(props: PropTypes) {
  const [editMode, setEditMode] = useState(false);

  return (
    <DocumentUploaded>
      {!editMode ? (
        <div onClick={() => setEditMode(true)}>
          <span>{props.fileNameToDisplay}</span>
          <div
            onClick={props.onRemoveClick}
            style={{ position: 'absolute', right: 16, top: 8, cursor: 'pointer' }}
          >
            <XIcon />
          </div>
        </div>
      ) : (
        <InputStyles
          autoFocus
          type="text"
          onKeyDown={(e: any) => {
            if (e.key === 'Enter') {
              if (e.target.value !== props.fileNameToDisplay) {
                props.changeCustomFileName(e.target.value);
              }
              setEditMode(false);
            }
          }}
          defaultValue={props.fileNameToDisplay}
          onBlur={e => {
            setEditMode(false);
            if (e.target.value !== props.fileNameToDisplay) {
              props.changeCustomFileName(e.target.value);
            }
          }}
        />
      )}
    </DocumentUploaded>
  );
}

export default ImportedFileTag;
